<template>
    Loading <span class="loading__ticker">{{ ticker }}</span>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

const ticker = ref('');
onMounted(() => {
    const interval = setInterval(() => {
        if (ticker.value.length >= 3) {
            ticker.value = '';
        }

        ticker.value += '.';
    }, 250);

    onUnmounted(() => {
        clearInterval(interval);
    });
});
</script>
